import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import createMiddleware from "redux-saga";
import App from "./App";
import rootReducer from "./store/reducers/index";
import { rootSaga } from "./store/sagas/index";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import TagManager from "react-gtm-module";

import "./index.css";
import "./style.scss";

if (process.env.REACT_APP_NODE_ENV === 'production') {
	const tagManagerArgs = {
		gtmId: "GTM-PPQ699M",
	};
	TagManager.initialize(tagManagerArgs);
}
const sagaMiddleware = createMiddleware();
const RootApp = (
	process.env.REACT_APP_NODE_ENV === 'production'
		? <App />
		: <StrictMode><App /></StrictMode>
);

const container = document.getElementById("root");
if (!container) {
	throw new Error("Root element not found. Please ensure there is an element with id 'root' in your HTML.");
}
const root = createRoot(container);
root.render(
	<Provider store={createStore(rootReducer, applyMiddleware(sagaMiddleware))}>
		{RootApp}
	</Provider>
);
sagaMiddleware.run(rootSaga);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
if (process.env.NODE_ENV === 'development') {
	serviceWorker.register();
} else {
	serviceWorker.unregister();
	// Force clear any existing service workers in production
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for(let registration of registrations) {
				registration.unregister();
			}
		});
	}
}
